import { GetHallOfFameGameResult } from "results/hall-of-fame/GetHallOfFameGameResult";
import { GetHallOfFamePreviewResult } from "results/hall-of-fame/GetHallOfFamePreviewResult";
import { GetHallOfFameResult } from "results/hall-of-fame/GetHallOfFameResult";
import { GetHallOfFameSearchResult } from "results/hall-of-fame/GetHallOfFameSearchResult";
import { useApiService } from "services/ApiService";

export const HallOfFameApiService = () => {
    const { get } = useApiService({ controller: "/halloffame" });

    // get the user's current language
    const { language } = new Intl.Locale(navigator.language);

    return {
        getHallOfFame: (country: string) => get<GetHallOfFameResult>(`/?country=${country}&language=${language}`),
        getHallOfFameGame: (code: string, country: string) => get<GetHallOfFameGameResult>(`/game/${code}/${country}`),
        search: (
            query: string,
            category?: number,
            searchLanguage?: string,
            country?: string,
            region?: string,
            schoolLevel?: number,
        ) => {
            const params = new URLSearchParams();
            params.set("query", query);

            if (category !== undefined) {
                params.set("category", category.toString());
            }
            if (searchLanguage) {
                params.set("language", searchLanguage);
            }
            if (country) {
                params.set("country", country);
            }
            if (region) {
                params.set("region", region);
            }
            if (schoolLevel !== undefined) {
                params.set("schoolLevel", schoolLevel.toString());
            }

            return get<GetHallOfFameSearchResult>(`/search?${params.toString()}`);
        },
        getHallOfFamePreview: () => get<GetHallOfFamePreviewResult>("/preview"),
    };
};
